import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'csn-checkout-success',
  templateUrl: './checkout-success.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutSuccessComponent implements OnInit {
  state: 'loading' | 'success' | 'error' = 'loading';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private usersService: UsersService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    const sessionId = this.route.snapshot.queryParamMap.get('session_id');
    if (!sessionId) {
      this.state = 'error';
      this.cdr.markForCheck();
      return;
    }
    this.checkSession(sessionId);
  }

  private async checkSession(sessionId: string) {
    try {
      const session = await this.usersService.getCheckoutSessionStatus(sessionId);
      if (session.status === 'complete') {
        this.state = 'success';
        this.cdr.markForCheck();
        setTimeout(() => this.router.navigateByUrl('/courses/home'), 2000);
      } else {
        this.state = 'error';
        this.cdr.markForCheck();
      }
    } catch {
      this.state = 'error';
      this.cdr.markForCheck();
    }
  }
}
